import React from "react"
import PropTypes from "prop-types"

const Hint = ({ children }) => (
  <p className="text-xl leading-tight col-span-2 text-center font-bold text-neutral-800 mt-8 sm:text-3xl">
    {children}
  </p>
)

Hint.propTypes = {
  children: PropTypes.any,
}

export default Hint
